import { hasErrorMessage } from "@faire/typescript";
import { IImage } from "@faire/types-common-api/indigofair/data/IImage";
import isNil from "lodash/isNil";
import isObject from "lodash/isObject";

import { logger } from "../private/logger";
import { IOptimizeImageOptions } from "../types";

import {
  ALL_IMAGE_CROPPING_PREFIX,
  AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX,
  AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX,
} from "./autoImageCropTagPrefix";

//TODO: change this name to include auto cropped image.
export const isManuallyCroppedImage = (image?: Partial<IImage>) =>
  !!image && !!getCropTagParams(image);

export const isAutoCroppedApparelImage = (image?: Partial<IImage>): boolean => {
  const apparelTag = image?.tags?.find((tag) =>
    tag.startsWith(AUTO_IMAGE_CROP_APPAREL_TAG_PREFIX)
  );
  // TODO(leyao.zhang@faire.com): revisit product type check after we have the image type
  return !!apparelTag;
};

export const isAutoCroppedSquareImage = (image?: Partial<IImage>): boolean => {
  const squareTag = image?.tags?.find((tag) =>
    tag.startsWith(AUTO_IMAGE_CROP_SQUARE_TAG_PREFIX)
  );
  // TODO(leyao.zhang@faire.com): revisit product type check after we have the image type
  return !!squareTag;
};

export const getCropTagParams = (
  image: Partial<IImage>
): IOptimizeImageOptions["crop"] | undefined => {
  //there should only exist one crop tag
  const cropTag =
    image !== undefined &&
    image.url !== undefined &&
    Array.isArray(image.tags) &&
    image.tags
      .slice()
      // make sure manual crop takes precedence
      .sort()
      .reverse()
      .find((tag) =>
        ALL_IMAGE_CROPPING_PREFIX.find((prefix) => tag.startsWith(prefix))
      );
  if (cropTag) {
    try {
      const allCropPrefixPattern = new RegExp(
        ALL_IMAGE_CROPPING_PREFIX.join("|"),
        "g"
      );
      const crop = JSON.parse(
        cropTag.replace(allCropPrefixPattern, "")
      ) as IOptimizeImageOptions["crop"];

      if (
        crop &&
        (!crop.width || !crop.height || isNil(crop.x) || isNil(crop.y))
      ) {
        const error = new Error("getFastlyUrl - crop option is malformed");
        logger.error(error.message, error, { imageUrl: image.url, crop });
      } else {
        return crop;
      }
    } catch (error) {
      const fingerprint: string[] = [];
      if (isObject(error) && hasErrorMessage(error)) {
        fingerprint.push(error.message);
      } else {
        fingerprint.push("no error message provided");
      }

      fingerprint.push(image.url ?? "no image url provided");

      const wrappedError = new Error(
        "getCropTagParams - manual image crop tag is invalid"
      );
      logger.error(wrappedError.message, wrappedError, {
        imageUrl: image.url,
        cropTag,
        fingerprint,
      });
    }
  }
  return undefined;
};
